(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('EventFormAttachmentService', EventFormAttachmentService);

    EventFormAttachmentService.$inject = ['$http'];

    function EventFormAttachmentService($http) {
        return {
            query: query,
            upload: upload,
            download: download
        };

        function query(eventFormId) {
            return $http.get('api/form-event/' + eventFormId + '/attachments');
        }

        function upload(eventFormId, file) {
            var formData = new FormData();
            formData.append('file', file);
            return $http.post('api/form-event/' + eventFormId + '/attachments', formData, {
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                }
            });
        }

        function download(eventFormId, attachmentId) {
            return $http({
                url: 'api/form-event/' + eventFormId + '/attachments/' + attachmentId,
                method: 'GET',
                responseType: 'arraybuffer'
            }).then(function(response) {
                return {
                    response: new Blob([response.data], {
                        type: response.headers('Content-Type') || 'application/octet-stream'
                    }),
                    fileName: extractFileName(response.headers('Content-Disposition'))
                };
            });
        }

        function extractFileName(contentDisposition) {
            if (!contentDisposition) {
                return 'piece-jointe';
            }
            var match = /filename="([^"]+)"/i.exec(contentDisposition);
            return match && match[1] ? match[1] : 'piece-jointe';
        }
    }
})();
